import { PriceTabGrid } from "../price/priceTabGrid.tsx";

/**
 * Edit-Kiosk → Prices tab. Server-paged per-product price summary
 * (KIOSKPRICEGRID): one row per recent-inventory product with the resolved
 * Current Price/Tax, the resolved Source, and an editable kiosk-level override
 * value per price type. Edits buffer inline; Save All persists via
 * saveAdvancedPriceData. Replaces the old load-everything cascade table.
 */
export function KioskPricesTab({ kioskId, onReady }: { kioskId: number; onReady?: () => void }) {
  return (
    <PriceTabGrid
      gridName="KIOSKPRICEGRID"
      scope={{ kind: "kiosk", kioskId }}
      scopeParamColumn="KioskID"
      scopeParamValue={kioskId}
      onReady={onReady}
    />
  );
}
